import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { MaybeUndef } from 'types/UtilityTypes';
import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

import { toApiError } from './toApiError';

// Values returned by GET /integrations/portal/bid-rate-config/resolve
export enum PortalBidRateBasis {
  LineHaul = 'line_haul',
  TotalSell = 'total_sell',
}

export interface PortalBidRateResolutionRequest {
  integrationId: number;
  loadId: string;
  tmsCustomerId?: MaybeUndef<number>;
  customerName?: MaybeUndef<string>;
}

export interface PortalBidRateResolutionResponse {
  bidRateBasis: PortalBidRateBasis;
  source: string;
}

export async function getPortalBidRateResolution(
  request: PortalBidRateResolutionRequest
): Promise<Result<PortalBidRateResolutionResponse, ApiError>> {
  try {
    const params: Record<string, string> = {
      integrationId: String(request.integrationId),
      loadId: request.loadId.trim(),
    };

    if (request.tmsCustomerId != null && request.tmsCustomerId > 0) {
      params.tmsCustomerId = String(request.tmsCustomerId);
    }

    const customerName = request.customerName?.trim();
    if (customerName) {
      params.customerName = customerName;
    }

    const { data } = await axios.get<PortalBidRateResolutionResponse>(
      '/integrations/portal/bid-rate-config/resolve',
      {
        params,
      }
    );

    if (
      data?.bidRateBasis !== PortalBidRateBasis.LineHaul &&
      data?.bidRateBasis !== PortalBidRateBasis.TotalSell
    ) {
      return err({
        message: 'Portal bid-rate resolution response missing bidRateBasis',
      });
    }

    return ok(data);
  } catch (error) {
    captureException(error, { functionName: 'getPortalBidRateResolution' });

    if (!isAxiosError(error)) {
      return err({
        message: 'Failed to resolve portal bid rate basis',
      });
    }

    return err(
      toApiError(
        error,
        'Failed to resolve portal bid rate basis',
        error.response?.status
      )
    );
  }
}
